"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCurrentWidth = void 0;
var _useWindowDimensions2 = require("../useWindowDimensions/useWindowDimensions");
/**
 * Use this hook to get changes in viewport width. Useful when trying to
 * to implement responsiveness.
 *
 * @returns {number}
 */
var useCurrentWidth = exports.useCurrentWidth = function useCurrentWidth() {
  var _useWindowDimensions = (0, _useWindowDimensions2.useWindowDimensions)(),
    width = _useWindowDimensions.width;
  return width;
};